/// As 27 unidades da federação, na ordem em que a pessoa procura: alfabética pela sigla.
export const BRAZILIAN_STATES = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MG',
  'MS',
  'MT',
  'PA',
  'PB',
  'PE',
  'PI',
  'PR',
  'RJ',
  'RN',
  'RO',
  'RR',
  'RS',
  'SC',
  'SE',
  'SP',
  'TO',
] as const;
export type BrazilianState = (typeof BRAZILIAN_STATES)[number];

export function isBrazilianPostalCode(value: string): boolean {
  return /^\d{8}$/u.test(value);
}

/// O usuário do Instagram, sem "@" e sem o endereço do perfil — colar o link é o jeito mais comum
/// de preencher. Nulo quando o que sobra não é um usuário possível (1 a 30 letras, números, ponto
/// ou sublinhado).
export function normalizeInstagram(value: string | null | undefined): string | null | undefined {
  const raw = (value ?? '').trim();
  if (!raw) return null;
  const handle = raw
    .replace(/^https?:\/\//iu, '')
    .replace(/^(www\.)?instagram\.com\//iu, '')
    .replace(/[/?#].*$/u, '')
    .replace(/^@/u, '')
    .toLowerCase();
  return /^[a-z0-9._]{1,30}$/u.test(handle) ? handle : undefined;
}

/// Os países que a numeração telefônica conhece — é a lista mais completa à mão e já vem com o
/// pacote. O nome em português sai de `Intl.DisplayNames` em quem mostra.
export { getCountries as countryCodes } from 'libphonenumber-js';
